/*global veloxScriptLoader, VeloxWebView*/


/**
 * Extension to search cities in ZIP Codes
 */
var extension = {} ;
extension.name = "zip-codes" ;

//must run after fields
extension.mustRunAfter = ["fields", "country"] ;

extension.extendsGlobal = {};
extension.extendsGlobal.zip = {};


var zipCodes = null;
var zipCodesCountry = null;
function loadZips(callback){
    if(zipCodes && zipCodesCountry === VeloxWebView.country.get()){
        return callback() ;//already loaded
    }

    veloxScriptLoader.load([
        {name: "zipcodes-"+VeloxWebView.country.get(),
            type: "json",
            version: "1.0.0",
            localPath: "zip/"+VeloxWebView.country.get()+".json",
        }
    ], function(err, results){
        if(err){ return callback(err) ;}
        zipCodes = results[0][0] ;
        zipCodesCountry = VeloxWebView.country.get() ;
        callback() ;
    }) ;
}

extension.init = function(){
    var view = this ;
    view.on("initDone", function(){
        var selectors = ['[data-field-def="customer.c_zipcode"]', '[data-field-def="reseller.r_zipcode"]'] ;
        var zipEls = [] ;
        selectors.forEach(function(sel){
            var els = view.viewRootEl.querySelectorAll(sel);
            for(var i=0; i<els.length; i++){
                zipEls.push(els[i]) ;
            }
        }) ;
        for(var i=0; i<zipEls.length; i++){
            var zipEl = zipEls[i] ;
            var idCity = zipEl.getAttribute("data-field-city") ;
            if(idCity && view.EL[idCity]){
                var elCity = view.EL[idCity] ;
                if(!elCity.listenerZip){
                    elCity.listenerZip = true ;
                    zipEl.addEventListener("blur", function(){
                        if(elCity.getValue()){ return ;} //don't change city if already set
    
                        var possibleCities = null;

                        view.longTask(function(done){
                            if(!zipEl.getValue()){
                                return done() ;
                            }
                            loadZips(function(err){
                                if(err){ return done(err) ;}
                                var zips = zipCodes[zipEl.getValue()] ;
                                if(!zips){
                                    return done() ;
                                }
                                possibleCities = zips.map(function(c){
                                    //remove district number (ex : Lyon 01 -> Lyon)
                                    return c.replace(/ [0-9]+$/, "") ;
                                }) ;
                                done() ;
                            }) ;
                        }, function(){
                            if(possibleCities){
                                if(possibleCities.length===1){
                                    elCity.setValue(possibleCities[0]) ;
                                }else if(possibleCities.length>1){
                                    var viewPopup = new VeloxWebView({
                                        css: ".zip-choose-city:hover { background }",
                                        html: '<div class="list-group">'+
                                            '<a class="list-group-item list-group-item-action" id="city" data-bind="cities[]"><span data-bind="$this"></span></a>'+
                                        '</div>'
                                    }) ;
                                    viewPopup.on("initDone", function(){
                                        viewPopup.EL.city.addEventListener("click", function(ev){
                                            elCity.setValue(ev.viewOfElement.getBoundObject());
                                            viewPopup.close() ;
                                        });
                                        viewPopup.render({cities : possibleCities}) ;
                                    });
                                    viewPopup.openInPopup({
                                        title: VeloxWebView.tr("form.zipCodeChooseCity")
                                    }, function(){
                                    }) ;
                                }
                            }
                        }) ;
                    }) ;
                }
            }
        }
    }) ;
} ;




module.exports = extension ;